import { getMenuList } from '@/api/menu';
import { getCollectList } from '@/api/bi/collect.js';
import { exportMenu } from "@/api/bi/reportTable";
import { getLoginData } from "@/api/login";
export default {

    /**
     * 设置我的报表自定义菜单栏
     * @param {*} param0 
     * @param {*} value 
     */
    setCustomerMenu({ commit }, value) {
        localStorage.setItem('customerReportMenuList', JSON.stringify(value || []));
        commit('SET_CUSTOMER_REPORT_MENU', value);
    },
    setActiveMenu({ commit }, menuId) {
        commit('SET_ACTIVE_MENU', menuId);
    },
    selectMenuList({ commit }) {
        return new Promise((resolve, reject) => {
            getMenuList().then(res => {
                commit('SET_MENUS_LIST', res.data);
                resolve(res.data);
            }).catch(err => {
                reject([]);
            });
        });
    },
    setActiveTopMenu({ commit }, id) {
        sessionStorage.setItem('topMenuId', id);
        commit('SET_ACTIVE_TOP_MENU_ID', id); 
    },
    /**
     * 查询自定义报表（列表）
     * @param {*} param0 
     */
    selectCustomerList({ commit }) {
        exportMenu().then(res => {
            let { data=[] } = res;
            commit('SET_CUSTOMER_REPORT_MENU', data);
        }).catch(err => {
        });
    },
    /**
     * 查询登录的用户信息
     * @param {*} param0 
     * @returns 
     */
    selectUserInfo({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            getLoginData().then(res => {
                commit('SET_USER_INFO', res.data);
                // 获取完用户信息后，拉取收藏列表
                dispatch('getCollectListAction');
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    /**
     * 查询常用报表列表
     * @param {*} param0 
     */
    getCollectListAction({ commit }) {
        return new Promise((resolve, reject) => {
            getCollectList().then(res => {
                commit('SET_COLLECT_LIST', res.data || []);
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }
}